import { createDinero } from '@mr-yum/frontend-core/dist/services/createDinero'
import cn from 'classnames'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TableCell, TableRow } from './shared'
import { LineItemsProps, OrderItemsProps } from './types'

const LineItems = ({
  lineItems,
  parentId = null,
  currency,
}: LineItemsProps) => (
  <div className={cn({ 'ml-2': parentId })}>
    {lineItems
      .filter((item) => item.parentId === parentId)
      .map((item) => (
        <React.Fragment key={item.id}>
          <TableRow>
            <>
              <TableCell className="flex-1">
                {item.type === 'CUSTOM_REFUND' && (
                  <FormattedMessage
                    defaultMessage="Custom amount"
                    id="/t9a6u"
                  />
                )}
                {item.type !== 'CUSTOM_REFUND' ? item.name : ''}
              </TableCell>
            </>

            <TableCell className="text-right">
              {'notRefundedParentItem' in item
                ? ''
                : createDinero(item.priceTaxDependentInCents, currency)
                    .multiply(item.quantity)
                    .toFormat()}
            </TableCell>
          </TableRow>

          {item.quantity > 1 && (
            <div className="mb-2 ml-2 text-foreground-subtle">
              {item.quantity} x{' '}
              {createDinero(
                Math.abs(item.priceTaxDependentInCents),
                currency,
              ).toFormat()}
            </div>
          )}

          <LineItems
            currency={currency}
            lineItems={lineItems}
            parentId={item.id}
          />
          {item.notes && (
            <div className="mb-2 ml-2 text-foreground-subtle">
              "{item.notes}"
            </div>
          )}
        </React.Fragment>
      ))}
  </div>
)

export const OrderItems = ({ lineItems, currency }: OrderItemsProps) => (
  <>
    <LineItems currency={currency} lineItems={lineItems} />
  </>
)
